import { getActiveLanguage, getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import React from 'react';
import { Table } from 'react-bootstrap';
import { getLocalizedName } from '../localization/LocalizedString';

class InstallationServiceAdditionalServices extends React.Component {
  render() {
    const {
      translate,
      currentLanguage,
      importedDeviceAdditionalProducts,
      selectedDeviceAdditionalProducts,
      onAddToDeviceList,
      onRemoveFromDeviceList,
    } = this.props;

    return (
      <div>
        <Table bordered>
          <thead className="table-head">
            <tr>
              <th>{translate('service_installation.installation_services_title')}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div className="row">
                  <div className="column table-body-padding">
                    <Table className="restricted-device-table" bordered responsive>
                      <thead className="device-table-header">
                        <tr>
                          <th>{translate('service_installation.name')}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {importedDeviceAdditionalProducts.map((additionalService) => (
                          <tr key={additionalService.id}>
                            <td>
                              <p>{getLocalizedName(additionalService, currentLanguage)}</p>
                            </td>
                            <td className="device-table-button">
                              <button
                            className="table-button-property table-button-add"
                            type="button"
                            onClick={() => onAddToDeviceList(additionalService)}>
                                <i className="fa fa-plus" />
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>

                  <div className="table-body-padding column">
                    <Table className="restricted-device-table" bordered responsive>
                      <thead className="device-table-header">
                        <tr>
                          <th>{translate('service_installation.name')}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedDeviceAdditionalProducts.map((additionalService, idx) => (
                          <tr key={idx}>
                            <td className="device-list-header">
                              <p>{getLocalizedName(additionalService, currentLanguage)}</p>
                            </td>
                            <td className="device-table-button">
                              <button
                            className="table-button-property table-button-remove"
                            onClick={() => onRemoveFromDeviceList(additionalService)}
                            type="button">
                                <i className="fa fa-minus" />
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currentLanguage: getActiveLanguage(state.locale).code,
  translate: getTranslate(state.locale),
  session: state.session,
});

export default connect(
  mapStateToProps,
  null,
)(InstallationServiceAdditionalServices);



// WEBPACK FOOTER //
// ./src/views/InstallationServiceAdditionalServices.js